import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const rootApi = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: "https://apis.sihs.org.pk/api",
    prepareHeaders: (headers, { getState }) => {
      const token = getState()?.auth?.token || localStorage.getItem("authToken");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      } else {
        console.log("No Authorization Token Found");
      }
      return headers;
    },
  }),
  tagTypes: [
    "departments",
    "department-doctors",
    "appointment-dates",
    "appointment-list",
    "report-link",
    "reports-list",
    "patient-list",
    "set-patient",
    "slider-list",
    "dashboard-items",
    "about-us",
    "hospital-encounters",
    "report-count",
    "lab-tests",
  ],
  endpoints: (builder) => ({
    // Fetch Patient List
    getPatientList: builder.query({
      query: (phone) => `/PatientPortal/GetPatientList?PhoneNo=${phone}`,
      responseHandler: "json", // Handle as JSON response
      transformResponse: (response) => {
        // Extract and return the Table array from the response
        if (response?.Table && Array.isArray(response.Table)) {
          return response.Table;
        }
        console.error("Unexpected API response structure:", response);
        return [];
      },
      providesTags: ["patient-list"],
    }),

    // Select Patient Mutation
    selectPatient: builder.mutation({
      query: (patientId) => ({
        url: "/PatientPortal/SetDefaultPatient",
        method: "POST",
        body: { patientId },
      }),
    }),

    // Other existing endpoints remain unchanged
    fetchDepartments: builder.query({
      query: () => "/Departments",
      providesTags: ["departments"],
    }),
    fetchDoctorsByDepartment: builder.query({
      query: (departmentId) => `/Departments/${departmentId}/Doctors`,
      providesTags: ["department-doctors"],
    }),

    fetchLabTests: builder.query({
      query: (payload) => ({
        url: `/PatientPortal/GetLAB_RAD_Services?Type=${payload.type}`,
        method: "GET",
      }),
      transformResponse: (response) => {
        console.log("Raw API Response:", response);
        if (response && response.Table) {
          return response.Table;
        } else {
          console.error("Unexpected API response structure for Lab Tests:", response);
          return [];
        }
      },
      providesTags: ["lab-tests"],
    }),

    // Validate CNIC
    validateCnic: builder.query({
      query: ({ phoneNo, cnic }) => ({
        url: `/PatientPortal/ValidatePatientCNIC?PhoneNo=${phoneNo}&CNIC=${cnic}`,
        method: "GET",
      }),
      transformResponse: (response) => {
        console.log("CNIC Validation Response:", response);
        if (response && response.Table && response.Table[0]) {
          return response.Table[0];
        }
        return { Status: "Invalid Response" };
      },
    }),
  }),
});

export const {
  useSetPatientMutation,
  useFetchDepartmentsQuery,
  useFetchDoctorsByDepartmentQuery,
  useFetchAppointmentsQuery,
  useBookAppointmentMutation,
  useFetchReportsListQuery,
  useFetchReportLinkQuery,
  useFetchDashboardItemsQuery,
  useFetchAboutUsQuery,
  useFetchHospitalEncountersQuery,
  useFetchReportCountQuery,
  useFetchLabTestsQuery,
  useVerifyOtpMutation,
  useGetPatientListQuery,
  useSelectPatientMutation,
  useLazyValidateCnicQuery,
} = rootApi;
